import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Alert, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { credentialPurposeCopy } from './credentialStatus';
export const EMPTY_PENDING_CREDENTIAL = {
  username: '',
  password: '',
  accountReference: ''
};

/**
 * Credential fields for the ADD path, where no property utility exists yet.
 *
 * Holds its own state and reports it through `dataRef` rather than an onChange prop. That is the
 * pattern this repo requires inside SimpleModal: a parent that re-renders on every keystroke can
 * remount the modal's children and drop focus after one character (see root CLAUDE.md).
 *
 * It calls no API. The parent posts the values only AFTER the property utility has been created and
 * its id resolved, because a credential row has to reference a real propertyUtilityId. Doing the
 * POST from here would either invent an id or write an unscoped credential nothing could find again.
 */
export const PendingCredentialFields = _ref => {
  let dataRef = _ref.dataRef,
    providerName = _ref.providerName,
    isAutomated = _ref.isAutomated;
  const _useState = useState(_objectSpread({}, EMPTY_PENDING_CREDENTIAL)),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];

  // Sync to the parent without re-rendering it. Assigning during render is intentional here: the
  // parent only ever reads this on submit.
  if (dataRef) dataRef.current = value;
  const createChangeHandler = field => event => {
    const fieldValue = event.target.value;
    setValue(current => _objectSpread(_objectSpread({}, current), {}, {
      [field]: fieldValue
    }));
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, "Bill automation (optional)"), /*#__PURE__*/React.createElement(Typography, {
    variant: "body2",
    sx: {
      marginY: '8px'
    }
  }, credentialPurposeCopy(providerName, isAutomated), " Credentials are encrypted before storage and are never displayed again."), /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      marginBottom: '16px'
    }
  }, "Credentials are saved after the utility itself is created. If that second step fails, the utility is still saved and you can add the login from the property's utility list."), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    spacing: 20
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "portal-username",
    label: "Portal username",
    value: value.username,
    onChange: createChangeHandler('username'),
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "portal-password",
    type: "password",
    label: "Portal password",
    value: value.password,
    onChange: createChangeHandler('password'),
    autoComplete: "new-password"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 6
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    id: "portal-account-reference",
    label: "Account number (optional)",
    value: value.accountReference,
    onChange: createChangeHandler('accountReference')
  }))));
};